module.exports = __webpack_public_path__ + "static/fonts/remixicon.9915fef9.9915fef9.woff2";